// Generated by CoffeeScript 2.7.0
var Admin__AccessesController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import AccessContainer from 'trunks/vue/admin/components/access/access_container.js';

export default Admin__AccessesController = (function() {
  class Admin__AccessesController extends Skylark.App.BaseController {
    index() {
      var access_container, actions;
      access_container = DomMaster.find("#js-access-container").node;
      actions = this.getVars("accesses");
      return Skylark.Libs.Ajax.get("/admin/accesses", {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: function(data) {
          return new AccessContainer({
            el: access_container,
            propsData: {
              result: data,
              actions: actions
            }
          });
        }
      });
    }

  };

  Admin__AccessesController.include(GenerateMorePopover);

  return Admin__AccessesController;

}).call(this);
